import React, { useMemo, useState } from 'react';

import './RecipeList.scss';
import Filter from '../Filter/Filter';
import RecipeItem from '../RecipeItem/RecipeItem';
import RecipeDetails from '../RecipeDetails/RecipeDetails';

const DEFAULT_SELECTED_FILTERS = {};

const getRecipe = (allRecipes, recipeId) => allRecipes.find(({ id }) => id === recipeId);

const RecipeList = ({
  allFilters,
  allRecipes,
  handleShowDetails,
  handleCloseDetails,
  removeRecipe,
  saveRecipe,
  savedRecipes,
  selectedRecipeId,
}) => {
  const filterCategories = useMemo(() => Object.keys(allFilters), [allFilters]);

  const [selectedFilters, setSelectedFilters] = useState(DEFAULT_SELECTED_FILTERS);

  const filteredRecipes = useMemo(() => allRecipes.filter(({ tags }) => {
    let includeRecipe = true;
    filterCategories.forEach(filterType => {
      const selectedFilter = selectedFilters[filterType];
      if (selectedFilter && !tags.includes(selectedFilter)) includeRecipe = false;
    });
    return includeRecipe;
  }), [allRecipes, filterCategories, selectedFilters]);

  const setFilter = (filterType, selectedOption) => {
    setSelectedFilters(prev => ({ ...prev, [filterType]: selectedOption }));
  }

  const clearAllFilters = () => {
    setSelectedFilters(DEFAULT_SELECTED_FILTERS);
  };

  if (selectedRecipeId) {
    const recipe = getRecipe(allRecipes, selectedRecipeId);
    if (recipe) {
      return (
        <RecipeDetails
          handleCloseDetails={handleCloseDetails}
          recipe={recipe}
          handleRemove={removeRecipe}
          handleSave={saveRecipe}
          isSaved={savedRecipes.includes(recipe.id)}
        />
      );
    }
  }

  return (
    <div className="recipe-list-container">
      {filterCategories.length ? (
        <>
          <div className="filters-container">
            {filterCategories.map(filterType => (
              <Filter
                key={filterType}
                title={filterType}
                options={allFilters[filterType]}
                selectedOption={selectedFilters[filterType]}
                setFilter={(selectedOption) => setFilter(filterType, selectedOption)}
              />
            ))}
          </div>
        <button className="clear-filters-button" onClick={clearAllFilters}>Clear All Filters</button>
        </>
      ) : null}
      <div className="grid">
        {filteredRecipes.map(recipe => (
          <RecipeItem
            key={recipe.id}
            handleRemove={removeRecipe}
            handleSave={saveRecipe}
            handleShowDetails={handleShowDetails}
            isSaved={savedRecipes.includes(recipe.id)}
            recipe={recipe}
          />
        ))}
        <div className="empty-message">
          {allRecipes.length === 0 ? (
            'Loading...'
          ) : filteredRecipes.length === 0 ? (
            'No recipes match your filter settings. Change your filters to see more recipes.'
          ) : null}
        </div>
      </div>
    </div>
  );
};

export default RecipeList;
